import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'

import { httpOk, DELETE, GET, POST, PUT } from 'helpers/api'
import { formatMoneyInput } from 'helpers/helpers'

function CreateUpdateCheque() {
	const { t } = useTranslation()
	const { id } = useParams()
	const navigate = useNavigate()

	const [poses, setPoses] = useState([])
	const [data, setData] = useState({
		"name": "",
		"cheque_amount": "",
		"discount_payment_type": 2,
		"discount_payment_value": "",
		"discount_hall": true,
		"discount_takeaway": false,
		"discount_delivery": false,
		"days": [],
		"poses": [],
	})

	async function createUpdate() {
		var dataCopy = { ...data }

		var response
		if (!dataCopy.id) {
			response = await POST('/discount/services-cheque-auto', dataCopy, { loader: true })
		} else {
			response = await PUT('/discount/services-cheque-auto', dataCopy, { loader: true })
		}

		if (httpOk(response)) navigate(-1)
	}

	function handleChangeTime(e, index, type) {
		var dataCopy = { ...data }

		if (type === 'start_time') {
			dataCopy.days[index]['start_time'] = e.target.value
		}
		if (type === 'end_time') {
			dataCopy.days[index]['end_time'] = e.target.value
		}

		setData(dataCopy)
	}

	function setDayStatus(index, key) {
		var dataCopy = { ...data }
		dataCopy.days[index][key] = !dataCopy.days[index][key]

		setData(dataCopy)
	}

	function addTime() {
		var dataCopy = { ...data }
		var item = {
			"start_time": "",
			"end_time": "",
			"day1": false,
			"day2": false,
			"day3": false,
			"day4": false,
			"day5": false,
			"day6": false,
			"day7": false,
		}
		dataCopy.days.push(item)

		setData(dataCopy)
	}

	async function deleteDay(item, index) {
		var dataCopy = { ...data }
		if (item.id) {
			const response = await DELETE(`/discount/services-dish-day/${item.id}`, {}, { loader: true })
			if (httpOk(response)) {
				dataCopy.days.splice(index, 1)
			}
		} else {
			dataCopy.days.splice(index, 1)
		}

		setData(dataCopy)
	}

	async function getData() {
		const response = await GET('/helper/poses', {}, { loader: true })
		if (httpOk(response)) setPoses(response.data)
		if (id) {
			const response = await GET(`/discount/services-dish/${id}`, {}, { loader: true })
			if (httpOk(response)) setData(response.data)
		}
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex">
				<div className="d-flex text-truncate">
					<h4 className="vertical-center">
						{t('discounts')}
					</h4>
					<div className="vertical-center mt-1">
						<i className="uil uil-angle-double-right fz-20"></i>
					</div>
					<div className="vertical-center mt-1">
						<h6>{t('create')}</h6>
					</div>
				</div>
			</div>

			<div className="card mb-3">
				<div className="card-body">
					<div className="row">
						<div className="col-md-4 border-right">
							<div className="form-group">
								<label>{t('name2')}</label>
								<input type="text" className="form-control" name="name" autoComplete="off"
									value={data.name ?? ''}
									onChange={(e) => setData({ ...data, 'name': e.target.value })} />
							</div>
							<div className="form-group">
								<label>{t('poses')}<span className="required-mark">*</span></label>
								<Select
									isMulti
									value={data.poses}
									options={poses}
									onChange={(options) => setData({ ...data, 'poses': options })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>

							<div className="d-flex gap-3">
								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setData({ ...data, 'discount_payment_type': 2 })}
										style={{ 'backgroundColor': data.discount_payment_type === 2 ? 'black' : '' }}>
									</div>
									<span onClick={() => setData({ ...data, 'discount_payment_type': 2 })}>
										{t('percentage')}
									</span>
								</div>

								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setData({ ...data, 'discount_payment_type': 1 })}
										style={{ 'backgroundColor': data.discount_payment_type === 1 ? 'black' : '' }}>
									</div>
									<span onClick={() => setData({ ...data, 'discount_payment_type': 1 })}>
										{t('amount')}
									</span>
								</div>
							</div>

							<div className="d-flex gap-2">
								<div className="form-group w-100">
									<label>{t('discount_value')}</label>
									<input type="text" className="form-control" name="discount_payment_value" autoComplete="off"
										value={formatMoneyInput(data.discount_payment_value) ?? ''}
										onChange={(e) => setData({ ...data, 'discount_payment_value': e.target.value.replace(/[^0-9.]/g, '') })} />
								</div>
								<div className="form-group w-100">
									<label>{t('amount')}</label>
									<input type="text" className="form-control" name="cheque_amount" autoComplete="off"
										value={formatMoneyInput(data.cheque_amount) ?? ''}
										onChange={(e) => setData({ ...data, 'cheque_amount': e.target.value.replace(/[^0-9.]/g, '') })} />
								</div>
							</div>
							<hr />
							<h5 className="mb-2">{t('order_type')}</h5>
							<div className="d-flex gap-3">
								<div className="form-check">
									<input type="checkbox" id="order_type_1" className="form-check-input"
										checked={data.discount_hall ?? false}
										onChange={(e) => setData({ ...data, 'discount_hall': e.target.checked })} />
									<label htmlFor="order_type_1" className="form-check-label">{t('hall')}</label>
								</div>
								<div className="form-check">
									<input type="checkbox" id="order_type_2" className="form-check-input"
										checked={data.discount_takeaway ?? false}
										onChange={(e) => setData({ ...data, 'discount_takeaway': e.target.checked })} />
									<label htmlFor="order_type_2" className="form-check-label">{t('takeaway')}</label>
								</div>
								<div className="form-check">
									<input type="checkbox" id="order_type_3" className="form-check-input"
										checked={data.discount_delivery ?? false}
										onChange={(e) => setData({ ...data, 'discount_delivery': e.target.checked })} />
									<label htmlFor="order_type_3" className="form-check-label">{t('delivery')}</label>
								</div>
							</div>
						</div>
						<div className="col-md-8">
							<div className="form-group">
								<div className="d-flex gap-2 mb-2">
									<h4 className="fw-600">{t('discount_day_time')}</h4>
									<div className="table-action-button table-action-primary-button"
										onClick={() => addTime()}>
										<i className="uil-plus"></i>
									</div>
								</div>
								<div className="table-responsive">
									<table className="table table-bordered mb-0">
										<thead>
											<tr>
												<th>{t('start')}</th>
												<th>{t('end')}</th>
												<th>{t('monday').substring(0, 2)}</th>
												<th>{t('tuesday').substring(0, 2)}</th>
												<th>{t('wednesday').substring(0, 2)}</th>
												<th>{t('thursday').substring(0, 2)}</th>
												<th>{t('friday').substring(0, 2)}</th>
												<th>{t('saturday').substring(0, 2)}</th>
												<th>{t('sunday').substring(0, 2)}</th>
												<th style={{ 'width': '50px' }}></th>
											</tr>
										</thead>
										<tbody>
											{data?.days?.map((item, index) => (
												<tr key={index}>
													<td>
														<input type="time"
															className="form-control"
															value={item.start_time ?? ''}
															onChange={(e) => handleChangeTime(e, index, 'start_time')} />
													</td>
													<td>
														<input type="time"
															className="form-control"
															value={item.end_time ?? ''}
															onChange={(e) => handleChangeTime(e, index, 'end_time')} />
													</td>
													<td className="vertical-middle">
														<input type="checkbox" className="form-check-input"
															checked={item.day1 ?? false}
															onChange={() => setDayStatus(index, 'day1')} />
													</td>
													<td className="vertical-middle">
														<input type="checkbox" className="form-check-input"
															checked={item.day2 ?? false}
															onChange={() => setDayStatus(index, 'day2')} />
													</td>
													<td className="vertical-middle">
														<input type="checkbox" className="form-check-input"
															checked={item.day3 ?? false}
															onChange={() => setDayStatus(index, 'day3')} />
													</td>
													<td className="vertical-middle">
														<input type="checkbox" className="form-check-input"
															checked={item.day4 ?? false}
															onChange={() => setDayStatus(index, 'day4')} />
													</td>
													<td className="vertical-middle">
														<input type="checkbox" className="form-check-input"
															checked={item.day5 ?? false}
															onChange={() => setDayStatus(index, 'day5')} />
													</td>
													<td className="vertical-middle">
														<input type="checkbox" className="form-check-input"
															checked={item.day6 ?? false}
															onChange={() => setDayStatus(index, 'day6')} />
													</td>
													<td className="vertical-middle">
														<input type="checkbox" className="form-check-input"
															checked={item.day7 ?? false}
															onChange={() => setDayStatus(index, 'day7')} />
													</td>
													<td>
														<div className="table-action-button table-action-danger-button"
															onClick={() => deleteDay(item, index)}>
															<i className="uil-times"></i>
														</div>
													</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>

					<div className="btn-wrapper gap-2">
						<Link className="btn btn-warning btn-rounded btn-wide" to="/discount/services" tabIndex="-1">
							{t('cancel')}
						</Link>
						<button type="button" className="btn btn-primary btn-rounded btn-wide" tabIndex="-1"
							onClick={() => createUpdate()}>
							{t('save')}
						</button>
					</div>

				</div>
			</div>
		</>
	)
}

export default CreateUpdateCheque